import useVuelidate, {
  type GlobalConfig,
  type Validation,
  type ValidationArgs,
} from '@vuelidate/core'
import type { ComputedGetter, ToRefs } from 'vue'

export function useValidation<T extends ValidationArgs<Partial<T>>>(
  rules: ComputedGetter<ValidationArgs<Partial<T>> | ValidationArgs>,
  state: T | Ref<T> | ToRefs<T>,
  globalConfig?: GlobalConfig
) {
  const $rules = computed(rules)
  return useVuelidate($rules, state, globalConfig) as Ref<Validation<ValidationArgs<T>, T>>
}
